module.exports = window["braintree"]["client"];